module.exports = __webpack_public_path__ + "static/img/page_14.61cb8815.png";